<template>
  <div>
    <Modal v-model="isShowModal" :title="title" @on-cancel="hide('formValidate')" :mask-closable="false"
           width="1200">
      <Card :bordered="false" :style="{marginBottom:'10px'}">
        <!--表格数据-->
        <Table :columns="columns" :data="data" size="small" :stripe="true" ref="selection2" :loading="isTableLoading">
          <template slot-scope="{ row, index}" slot="orderPay">
            <span v-if="row.orderPay">{{row.orderPay}}元</span>
          </template>

          <template slot-scope="{ row, index}" slot="vipPay">
            <span v-if="row.vipPay">{{row.vipPay}}元</span>
          </template>
        </Table>
        <!--分页-->
        <div class="hs-page">
          <Page :total="total" show-sizer show-total transfer @on-change="changePage"
                @on-page-size-change="changePageSize"/>
        </div>
      </Card>

      <!-- 重写对话框底部按钮 -->
      <div slot="footer">
        <Button @click="hide('formValidate')">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShowModal: false,
      loadingBtn: false,
      title: '邀请用户列表',
      total: 0,
      params: {
        page: 1,
        rows: 10,
        userId: ''
      },
      isTableLoading: false,
      // 表格列
      columns: [
        {
          title: '下级用户昵称',
          minWidth: 200,
          align: 'center',
          key: 'nickName'
        },
        {
          title: '邀请时间',
          minWidth: 150,
          align: 'center',
          key: 'createTime'
        },
        {
          title: '首单奖励',
          minWidth: 80,
          align: 'center',
          slot: 'orderPay'
        },
        {
          title: '首单奖励时间',
          minWidth: 150,
          align: 'center',
          key: 'orderPayTime'
        },
        {
          title: '首单单号',
          minWidth: 150,
          align: 'center',
          key: 'orderCode'
        },
        {
          title: '星标用户奖励',
          minWidth: 120,
          align: 'center',
          slot: 'vipPay'
        },
        {
          title: '星标用户奖励时间',
          minWidth: 150,
          align: 'center',
          key: 'vipPayTime'
        },
      ],
      // 表格数据
      data: [],
      userIds: []
    }
  },
  methods: {
    // 显示模态框
    show(row) {
      this.isShowModal = true;
      this.userIds = []
      this.params.userId = row.userId
      this.findList();
    },
    // 查询用户列表
    findList(userId) {
      this.$Spin.show();
      this.axios.post('/activityUser/findActivityInvitation', this.params).then(res => {
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询下级用户列表接口报错',
            duration: 0
          });
        }
      })
    },
    inited(viewer) {
      this.$viewer = viewer
    },
    // 关闭模态框
    hide(name) {
      this.isShowModal = false;
      // this.$refs[name].resetFields();
    },
    save() {
      if (this.userIds.length === 0) {
        this.$Notice.error({
          title: '添加失败',
          desc: '请先选择参与活动的用户！'
        });
        return ;
      }
      this.axios.post('/activityUser/saveActivityUser', {userArr: this.userIds}).then(res => {
        console.log(res);
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        this.isTableLoading = false;
        if (res.status == 201) {
          this.$Notice.error({
            title: '添加失败',
            desc: res.msg
          });
        }
        if (res.status == 200) {
          this.$emit('changeDate');
          this.userIds = []
          this.$Message.success('添加成功.');
          this.hide('formValidate');
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询用户列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
    handleSelectRow(index) {
      let ids=[];
      this.$refs['selection2'].getSelection().map(item=>{
        ids.push(item.userId)
      })
      this.userIds=ids
      console.log('ids', ids)
    },
    onSelect() {
      console.log()
    }
  },
}
</script>

<style scoped>
.jw-images-row {
  display: flex;
  align-items: center;
}

.jw-image {
  width: 150px;
  height: 150px;
  margin-right: 10px;
}
</style>
